export default function backendUrl() {
    let baseUrl;
    if (process.env.REACT_APP_ENV==="development"){
      baseUrl=process.env.REACT_APP_DEVELOPMENT_URL
    }else{
    baseUrl= process.env.REACT_APP_PRODUCTION_URL // Replace with your API URL
  }
    return baseUrl;
  }  